module.exports = __webpack_public_path__ + "img/news-5.389c0986.jpg";